import { Component, OnInit, ViewChild, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { FormGroup, FormControl, Validators, FormBuilder, FormGroupDirective } from '@angular/forms';
import { Constants } from '../common/constants/constants';
import { Http, ResponseContentType } from '@angular/http';
import { RestCallerService } from '../common/services/rest-caller.service';
import { CustomNumberValidator } from 'app/common/validator/number.validator';
import { environment } from '../../environments/environment';
import { CalculationEngineComponent } from '../calculation-engine/calculation-engine.component';
import { ReturnStatement } from '@angular/compiler/src/output/output_ast';

declare var $: any;
declare var alasql: any;
declare var swal: any;
declare var moment: any;
declare var ActiveXObject: any;

@Component({
  selector: 'app-client-payroll-management',
  templateUrl: './client-payroll-management.component.html',
  styleUrls: ['./client-payroll-management.component.css']
})

export class ClientPayrollManagementComponent implements OnInit, OnDestroy {

  @ViewChild(CalculationEngineComponent) calculationEngineComponent;

  showTextbox: boolean;
  constants: any;
  clientList: any;
  selectedClient: 0;

  employeeList: any;
  selectedEmployee: Object;
  isExternalClient: boolean;
  selectedRow: Number;

  lastQuarterStart: string;
  lastQuarterEnd: string;
  currentQuarterStart: string;
  currentQuarterEnd: string;
  showDocumentPortalLaunch: string;

  lastQuarterData: any;
  currentQuarterData: any;
  selectedPayrollData: any;
  isLastQuarterDataLoaded = false;

  showLoader: boolean;
  showEmployeeInfo = false;

  payDateInput: Date = new Date();
  startDateInput: Date = new Date();
  endDateInput: Date = new Date();

  quarterForm: FormGroup;
  clientForm: FormGroup;

  employeeWorkState: any;
  localWithholding: any;
  udfData: any;

  isFormReadOnly: boolean;

  workStateAbbv: string;

  public queryClientList = '';
  public filteredClientList = [];

  MCWHNumber: number;
  SSWHNumber: number;

  @ViewChild(FormGroupDirective) quarterFormDirective;

  min = 0;
  max = 1000000000;

  constructor(private restCallingService: RestCallerService, private decimalPipe: DecimalPipe, private http: Http) {
    this.showTextbox = false;
    this.constants = Constants;
    this.isExternalClient = this.restCallingService.getUserDetails()['externalUser'];
  }

  ngOnInit() {
    this.selectedClient = 0;
    if (sessionStorage.getItem('currentUser') !== null) {
      const configKeyValuePairs = JSON.parse(sessionStorage.getItem('currentUser'))['configKeyValuePairs'];
      this.currentQuarterStart = this.getQuarterDate(configKeyValuePairs['CURRENT_QUARTER_START_YYYYMMDD']);
      this.currentQuarterEnd = this.getQuarterDate(configKeyValuePairs['CURRENT_QUARTER_END_YYYYMMDD']);
      this.lastQuarterStart = this.getQuarterDate(configKeyValuePairs['LAST_QUARTER_START_YYYYMMDD']);
      this.lastQuarterEnd = this.getQuarterDate(configKeyValuePairs['LAST_QUARTER_END_YYYYMMDD']);
      this.showDocumentPortalLaunch = configKeyValuePairs['SHOW_DOCUMENT_PORTAL_LAUNCH'];

      $('#clientPortalModal').on('hidden.bs.modal', function () {
          $('#clientPortalIFrame').attr('src', '');
      })
    }

    //#region Load Client
    if (!this.isExternalClient) {
      // Call if the client is External.
      this.showLoader = true;
      this.restCallingService.getListofClientForInternalUser({}).subscribe(
        data => {
          this.showLoader = false;
          this.clientList = data.json().filter(function(a) { return (a.name !== null) && (a.payerId !== null); } ).sort(function (a, b) {
            if (a.name.toUpperCase() < b.name.toUpperCase()) { return -1; }
            if (a.name.toUpperCase() > b.name.toUpperCase()) { return 1; }
            return 0;
          });
        },
        err => {
          this.showLoader = false;
          console.log(err.json());
          swal('Failure!', err.json().message,'error');
        });
    } else {
      // Call when the client is Internal.
      this.showLoader = true;
      this.restCallingService.getListofClientForExternalUser({}).subscribe(
        data => {
          this.showLoader = false;
          this.clientList = data.json();
          if (this.clientList.length === 1) {
            this.showTextbox = true;
            this.onClientSelection(this.clientList[0]);
          }
        },
        err => {
          this.showLoader = false;
          console.log(err.json());
          swal('Failure!', err.json().message,'error');
        });
    }
    //#endregion

    this.quarterForm = new FormGroup({
      'payDate': new FormControl(null, [Validators.required, this.validateDate]),
      'startDate': new FormControl(null, this.validateDate),
      'endDate': new FormControl(null, this.validateDate),
      'allowanceType': new FormControl(null),
      'XFICA': new FormControl(null),
      'payFrequencyType': new FormControl(null, Validators.required),
      'grossPay': new FormControl(null, [Validators.required, CustomNumberValidator.checkLimit(this.min, this.max) ]),
      'netPay': new FormControl(null, [Validators.required, this.validateNetPay, CustomNumberValidator.checkLimit(this.min, this.max)]),
      'federalWithholding': new FormControl(null, CustomNumberValidator.checkLimit(this.min, this.max)),
      'medicareWithholding': new FormControl(null, CustomNumberValidator.checkLimit(this.min, this.max)),
      'socialSecurityWithholding': new FormControl(null, CustomNumberValidator.checkLimit(this.min, this.max)),
      'stateWithholding': new FormControl(null, CustomNumberValidator.checkLimit(this.min, this.max))
    });

    this.initializeFormElements();

    this.convertWithholdingPercentageToNumber();
  }

  ngOnDestroy() {
    $('.nav>li.active').removeClass('active');
  }

  showCalculationModal() {
    this.calculationEngineComponent.showModal();
  }

  convertWithholdingPercentageToNumber() {
    const  MCWH = "1.45%";
    const  SSWH = "6.2%";
    var parseMCWH = parseFloat(MCWH);
    if (parseMCWH != null) {
      this.MCWHNumber = parseMCWH / 100;
    }

    var parseSSWH = parseFloat(SSWH);
    if (parseSSWH != null) {
      this.SSWHNumber = parseSSWH / 100;
    }
  }

  isShowDocumentPortalLaunch() {
    if (!this.showDocumentPortalLaunch)
      return false;
    if (this.showDocumentPortalLaunch === null)
      return false;
    if (this.showDocumentPortalLaunch === "true")
      return true;
    return false;
  }

  //#region selection events

  onClientSelection(item) {
    this.selectedClient = item;
    this.queryClientList = item.name;
    this.filteredClientList = [];
    if (this.selectedClient !== 0) {
      this.selectedRow = null;
      this.selectedEmployee = null;
      this.showLoader = true;
      this.restCallingService.getEmployeesByClientId(this.selectedClient['id']).subscribe(
        empData => {
          this.showLoader = false;
          this.employeeList = empData.json();
        },
        err => {
          this.showLoader = false;
          console.log(err.json());
          swal('Failure!', err.json().message,'error');
        }
      );
    }
  }

  onEmployeeSelectionFromGrid(data, rowIndex) {
    if (data !== 0 && data !== undefined && data !== null) {
      this.selectedEmployee = data;
      this.employeeWorkState = data.workState;
      this.showEmployeeInfo = true;
      this.selectedRow = rowIndex;

      //#region Dynamic Fields.

      this.restCallingService.getClientUdfLookup(this.selectedClient['id']).subscribe(
        resp => {
          this.udfData = $.map(resp.json()[0], function (value, key) {
            if (value && key.indexOf('udf') > -1) {
              return { key, value };
            }
          });
          for (const udfField of this.udfData) {
            this.quarterForm.addControl(udfField.key, new FormControl(null, CustomNumberValidator.checkLimit(this.min, this.max)));
          }
          this.initializeFormElements();
        },
        err => {
          console.log(err.json());
          swal('Failure!', err.json().message,'error');
        });

      if ((Number(this.employeeWorkState[1]) !== 0 || Number(this.employeeWorkState[2]) !== 0) && this.employeeWorkState !== '') {
        const localFieldValueOne = !isNaN(this.employeeWorkState[1]) ? Number(this.employeeWorkState[1]) :
          this.employeeWorkState[1].toUpperCase().charCodeAt(0) - 55;
        const localFieldValueTwo = !isNaN(this.employeeWorkState[2]) ? Number(this.employeeWorkState[2]) :
          this.employeeWorkState[2].toUpperCase().charCodeAt(0) - 55;

        this.restCallingService.getClientLocalTaxLookup(this.selectedClient['id']).subscribe(
          resp => {
            const localFieldData = resp.json()[(this.employeeWorkState[0].toUpperCase().charCodeAt(0) - 65)];
            if (localFieldData.state)
              this.workStateAbbv = localFieldData.state;
            else
              this.workStateAbbv = this.selectedEmployee['state'];
            this.localWithholding = $.map(localFieldData, function (value, key) {
              if ((key.indexOf('local' + localFieldValueOne) > -1 || key.indexOf('local' + localFieldValueTwo) > -1) && value) {
                const newKey = key.replace('local', 'localWithholding');
                return { newKey, value };
              }
            });
            for (const localField of this.localWithholding) {
              this.quarterForm.addControl(localField.newKey, new FormControl(null, CustomNumberValidator.checkLimit(this.min, this.max)));
            }
          },
          err => {
            console.log(err.json());
            swal('Failure!', err.json().message,'error');
          });
      } else {
        this.localWithholding = [];
        this.workStateAbbv = this.selectedEmployee['state'];
      }

      //#endregion

      if ($('.current-quarter-icon').hasClass('fa-plus-circle')) {
        // open current quarter payroll if it's not open already
        this.toggleCurrentQuarterGrid();
      }
      this.loadCurrentQuarterData();
      if ($('.last-quarter-icon').hasClass('fa-minus-circle')) {
        // load last-quarter data if the tray is already open
        this.isLastQuarterDataLoaded = true;
        this.loadLastQuarterData();
      } else {
        this.isLastQuarterDataLoaded = false;
      }
    } else {
      this.selectedEmployee = null;
    }
  }

  viewSelectedRow(data) {
    this.editSelectedRow(data);
    this.isFormReadOnly = true;
  }

  editSelectedRow(data) {
    this.isFormReadOnly = false;
    if (data !== undefined) {
      this.quarterForm.reset();
      this.quarterFormDirective.reset();
      this.selectedPayrollData = Object.assign({}, data); //deep copy of data object so we're not modifying the table in memory
      for (const value in data) {
        if (this.quarterForm.controls[value] !== undefined) {
          this.quarterForm.controls[value].setValue(data[value]);
        }
      }
    }
    this.payDateInput = this.parseDate(data['payDate']);
    this.startDateInput = this.parseDate(data['startDate']);
    this.endDateInput = this.parseDate(data['endDate']);
    this.quarterForm.controls['payDate'].setValue(this.payDateInput);
    this.quarterForm.controls['startDate'].setValue(this.startDateInput);
    this.quarterForm.controls['endDate'].setValue(this.endDateInput);

    this.initializeFormElements();
    $('.two-place-decimal').trigger('change');
  }

  parseDate(dateString: string) {
    if (dateString) {
      return new moment(dateString).toDate();
    } else {
      return null;
    }
  }

  //#endregion

  //#region Load Payroll Data

  loadLastQuarterData() {
    this.showLoader = true;
    this.restCallingService.getEmployeePayrollV2DataForLastQuarter(this.selectedEmployee['id']).subscribe((lastPayRollData) => {
      this.showLoader = false;
      this.lastQuarterData = lastPayRollData.json();
    }, err => {
      this.showLoader = false;
      console.log(err.json());
      swal('Failure!', err.json().message,'error');
    });
  }

  loadCurrentQuarterData() {
    this.showLoader = true;
    this.restCallingService.getEmployeePayrollV2DataForCurrentQuarter(this.selectedEmployee['id']).subscribe((currentPayRollData) => {
      this.showLoader = false;
      this.currentQuarterData = currentPayRollData.json();
    }, err => {
      this.showLoader = false;
      console.log(err.json());
      swal('Failure!', err.json().message,'error');
    });
  }

  //#endregion

  //#region grid events

  savePayrollData() {
    if (this.quarterForm.valid === false) {
      // check for form validation.
      for (const fieldName of Object.keys(this.quarterForm.controls)) {
        if (this.quarterForm.controls[fieldName].valid === false) {
          this.quarterForm.controls[fieldName].markAsTouched({ onlySelf: true });
        }
      }
      swal('Failure!', 'Error: Please check one or more fields', 'error');
      return;
    }
    if (!this.validatePayDate(this.quarterForm.value.payDate)) {
      swal('Failure!', 'Error: Pay date does not fall within current quarter', 'error');
      return;
    }
    if (this.selectedPayrollData !== null && this.selectedPayrollData !== undefined) {
      if (this.payDateInput) {
        this.selectedPayrollData['payDate'] = moment(this.payDateInput).format('YYYY-MM-DD');
      }
      if (this.startDateInput) {
        this.selectedPayrollData['startDate'] = moment(this.startDateInput).format('YYYY-MM-DD');
      }
      else {
        this.selectedPayrollData['startDate'] = null;
      }
      if (this.endDateInput) {
        this.selectedPayrollData['endDate'] = moment(this.endDateInput).format('YYYY-MM-DD');
      }
      else {
        this.selectedPayrollData['endDate'] = null;
      }
      this.doWarningIfNecessaryBeforeUpdating(this.quarterForm.value);
    } else {
      // setting new value in an array
      const newPayrollData = this.quarterForm.value;
      newPayrollData.clientId = this.selectedClient['id'];
      newPayrollData.employeeId = this.selectedEmployee['id'];
      if (newPayrollData['payDate']) {
        newPayrollData['payDate'] = moment(this.payDateInput).format('YYYY-MM-DD');
      }
      if (newPayrollData['startDate']) {
        newPayrollData['startDate'] = moment(this.startDateInput).format('YYYY-MM-DD');
      }
      if (newPayrollData['endDate']) {
        newPayrollData['endDate'] = moment(this.endDateInput).format('YYYY-MM-DD');
      }
      this.doWarningIfNecessaryBeforeCreatingNew(newPayrollData);
    }
  }

  doWarningIfNecessaryBeforeCreatingNew(newPayRollData) {
    newPayRollData['isGrossToNetCheckRequested'] = true;
    this.showLoader = true;
    this.restCallingService.createNewPayrollV2(newPayRollData).subscribe(data => {
      this.showLoader = false;
      delete newPayRollData['isGrossToNetCheckRequested'];
      if (data.json()['isGrossToNetMathMatch'] && data.json()['isGrossToNetMathMatch']===true)
        this.callCreateNewPayrollService(newPayRollData);
      else  {
        var htmlText = document.createElement("span");
        htmlText.innerHTML = 'Total Deductions do not match difference between Gross and Net. Do you want to continue?<br /><br /><font color="red">Please confirm that the Net Pay amount is correct before continuing.</font>';
        swal({
          title: 'Are you sure?', content: htmlText,
          icon: 'warning', buttons: ['No', 'Yes']
        }).then(
          (isConfirmed) => {
            if (isConfirmed) {
              this.callCreateNewPayrollService(newPayRollData);
            }
          }
        );
      }
    }, err => {
      this.showLoader = false;
      delete newPayRollData['isGrossToNetCheckRequested'];
      swal('Failure!', err.json().message,'error');
      console.log(err.json());
    });
  }

  callCreateNewPayrollService(newPayRollData) {
    this.showLoader = true;
    this.restCallingService.createNewPayrollV2(newPayRollData).subscribe(data => {
      this.showLoader = false;
      newPayRollData.id = data.json()['id'];
      $('#quarterModal').modal('toggle');
      var htmlText = document.createElement("span");
      htmlText.innerHTML = 'New Payroll Data added Successfully!<br /><br /><font color="red">Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.</font>';
      swal({
        icon: 'success',
        title: 'Success!',
        content: htmlText,
      }).then(() => {
        this.displayWarningForLastRecordOfQuarter(newPayRollData);
        this.loadCurrentQuarterData();
      });
    }, err => {
      this.showLoader = false;
      swal('Failure!', err.json().message,'error');
      console.log(err.json());
    });
  }

  displayWarningForLastRecordOfQuarter(payRollData) {
    let quarterStartDateMoment = moment(this.currentQuarterStart);
    let quarterEndDateMoment = moment(this.currentQuarterEnd);
    let payDateMoment = moment(payRollData['payDate']);
    let nextpayDateMoment;
    if (payRollData['payFrequencyType'] === 'WEEKLY') {
      nextpayDateMoment = payDateMoment.add(7, 'days');
      if (nextpayDateMoment.isAfter(quarterEndDateMoment)) {
        this.displaySubmitWarningAlertBox();
      }
    } else if (payRollData['payFrequencyType'] === 'BI-WEEKLY') {
      nextpayDateMoment = payDateMoment.add(14, 'days');
      if (nextpayDateMoment.isAfter(quarterEndDateMoment)) {
        this.displaySubmitWarningAlertBox();
      }
    } else if (payRollData['payFrequencyType'] === 'MONTHLY') {
      nextpayDateMoment = payDateMoment.add(1, 'months');
      if (nextpayDateMoment.isAfter(quarterEndDateMoment)) {
        this.displaySubmitWarningAlertBox();
      }
    } else if (payRollData['payFrequencyType'] === 'QUARTERLY') {
      nextpayDateMoment = payDateMoment.add(3, 'months');
      if (nextpayDateMoment.isAfter(quarterEndDateMoment)) {
        this.displaySubmitWarningAlertBox();
      }
    } else if (payRollData['payFrequencyType'] === 'SEMI-MONTHLY') {
      if (payDateMoment.isSame(quarterEndDateMoment)) {
        this.displaySubmitWarningAlertBox();
      }
    }
  }

  displaySubmitWarningAlertBox() {
    swal({
      title: 'Submit Current Quarter!',
      text: 'Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.',
      icon: 'warning',
    });
  }

  fillSelectedPayrollData() {
    for (const data of Object.keys(this.selectedPayrollData)) {
      if (this.quarterForm.value[data] !== undefined && data != 'payDate' && data != 'startDate' && data!= 'endDate') { //we set the dates ourselves
        this.selectedPayrollData[data] = this.quarterForm.value[data];
      }
    }
  }

  doWarningIfNecessaryBeforeUpdating(payRollData) {
    payRollData['isGrossToNetCheckRequested'] = true;
    payRollData['id'] = this.selectedPayrollData['id'];
    payRollData['employeeId'] = this.selectedEmployee['id'];
    payRollData['clientId'] = this.selectedEmployee['clientId'];
    this.showLoader = true;
    this.restCallingService.updatePayrollV2(payRollData).subscribe(data => {
      this.showLoader = false;
      this.removeExtraFormProperties(payRollData);
      if (data.json()['isGrossToNetMathMatch'] && data.json()['isGrossToNetMathMatch']===true)
        this.callUpdatePayrollService();
      else  {
        var htmlText = document.createElement("span");
        htmlText.innerHTML = 'Total Deductions do not match difference between Gross and Net. Do you want to continue?<br /><br /><font color="red">Please confirm that the Net Pay amount is correct before continuing.</font>';
        swal({
          title: 'Are you sure?', content: htmlText,
          icon: 'warning', buttons: ['No', 'Yes']
        }).then(
          (isConfirmed) => {
            if (isConfirmed) {
              this.callUpdatePayrollService();
            }
          }
        );
      }
    }, err => {
      this.showLoader = false;
      this.removeExtraFormProperties(payRollData);
      swal('Failure!', err.json().message,'error');
      console.log(err.json());
    });
  }

  removeExtraFormProperties(payRollData) {
    delete payRollData['isGrossToNetCheckRequested'];
    delete payRollData['id'];
    delete payRollData['employeeId'];
    delete payRollData['clientId'];
  }

  callUpdatePayrollService() {
    // set modifed data from the modal to the object.
    this.fillSelectedPayrollData();
    this.showLoader = true;
    this.restCallingService.updatePayrollV2(this.selectedPayrollData).subscribe(data => {
      this.showLoader = false;
      $('#quarterModal').modal('toggle');
      var payrollDateClone = Object.assign({}, this.selectedPayrollData);
      this.selectedPayrollData = null;
      var updateHtmlText = document.createElement("span");
      updateHtmlText.innerHTML = 'Payroll Data Updated Successfully!<br /><br /><font color="red">Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.</font>';
      swal({
        icon: 'success',
        title: 'Success!',
        content: updateHtmlText,
      }).then(() => {
        this.displayWarningForLastRecordOfQuarter(payrollDateClone);
        this.loadCurrentQuarterData();
      });
    }, err => {
      this.showLoader = false;
      swal('Failure!', err.json().message,'error');
      console.log(err.json());
    });
  }

  deletePayroll(data) {
    swal({ title: 'Are you sure?', text: 'Are you sure you want to delete Payroll record?', icon: 'warning', buttons: true }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          this.showLoader = true;
          this.restCallingService.deletePayrollV2(data.id).subscribe(deleteResp => {
            this.showLoader = false;
            var deleteHtmlText = document.createElement("span");
            deleteHtmlText.innerHTML = 'Payroll Data Deleted Successfully!<br /><br /><font color="red">Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.</font>';
            swal({
              icon: 'success',
              title: 'Success!',
              content: deleteHtmlText,
            }).then(() => {
              this.loadCurrentQuarterData();
            });
          }, err => {
            this.showLoader = false;
            swal('Failure!', err.json().message,'error');
            console.log(err.json());
          });
        };
      }
    );
  }

  clonePayroll(data) {
    swal({ title: 'Are you sure?', text: 'Are you sure you want to clone this Payroll record?', icon: 'warning', buttons: true }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          let dataNew = Object.assign({}, data);
          dataNew['id'] = '';
          this.handleCloneDates(dataNew);
          this.showLoader = true;
          this.restCallingService.createNewPayrollV2(dataNew).subscribe(dataReturn => {
            this.showLoader = false;
            var cloneHtmlText = document.createElement("span");
            cloneHtmlText.innerHTML = 'New Payroll Data added Successfully!<br /><br /><font color="red">Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.</font>';
            swal({
              icon: 'success',
              title: 'Success!',
              content: cloneHtmlText,
            }).then(() => {
              this.displayWarningForLastRecordOfQuarter(dataNew);
              this.loadCurrentQuarterData();
            });
          }, err => {
            this.showLoader = false;
            swal('Failure!', err.json().message,'error');
            console.log(err.json());
          });
        };
      }
    );
  }

  handleCloneDates(data) {
    let quarterStartDateMoment = moment(this.currentQuarterStart);
    let quarterEndDateMoment = moment(this.currentQuarterEnd);
    let payDateMoment = moment(data['payDate']);
    let startDateMoment = moment(data['startDate']);
    let endDateMoment = moment(data['endDate']);
    let payDateMomentNew;
    let startDateMomentNew;
    let endDateMomentNew;
    if (payDateMoment.isBefore(quarterStartDateMoment)) {
      payDateMomentNew = payDateMoment.add(3,'months');
      if (startDateMoment.isValid())
        startDateMomentNew = startDateMoment.add(3,'months');
      if (endDateMoment.isValid())
        endDateMomentNew = endDateMoment.add(3,'months');
    }
    else {
      if (data['payFrequencyType']==='WEEKLY') {
        payDateMomentNew = payDateMoment.add(7,'days');
        if (startDateMoment.isValid())
          startDateMomentNew = startDateMoment.add(7,'days');
        if (endDateMoment.isValid())
          endDateMomentNew = endDateMoment.add(7,'days');
      }
      else if (data['payFrequencyType']==='BI-WEEKLY') {
        payDateMomentNew = payDateMoment.add(14,'days');
        if (startDateMoment.isValid())
          startDateMomentNew = startDateMoment.add(14,'days');
        if (endDateMoment.isValid())
          endDateMomentNew = endDateMoment.add(14,'days');
      }
      else if (data['payFrequencyType']==='MONTHLY') {
        payDateMomentNew = payDateMoment.add(1,'months');
        if (startDateMoment.isValid())
          startDateMomentNew = startDateMoment.add(1,'months');
        if (endDateMoment.isValid())
          endDateMomentNew = endDateMoment.add(1,'months');
      }
      else {
        payDateMomentNew = payDateMoment;
        if (startDateMoment.isValid())
          startDateMomentNew = startDateMoment;
        if (endDateMoment.isValid())
          endDateMomentNew = endDateMoment;
      }
    }
    data['payDate'] = (payDateMomentNew.isAfter(quarterEndDateMoment)) ? quarterEndDateMoment.format('YYYY-MM-DD') : payDateMomentNew.format('YYYY-MM-DD');
    if (startDateMoment.isValid())
      data['startDate'] = (startDateMomentNew.isAfter(quarterEndDateMoment)) ? quarterEndDateMoment.format('YYYY-MM-DD') : startDateMomentNew.format('YYYY-MM-DD');
    if (endDateMoment.isValid())
      data['endDate'] = (endDateMomentNew.isAfter(quarterEndDateMoment)) ? quarterEndDateMoment.format('YYYY-MM-DD') : endDateMomentNew.format('YYYY-MM-DD');
  }

  resetForm() {
    this.isFormReadOnly = false;
    this.selectedPayrollData = null;
    this.quarterForm.reset();
    this.quarterFormDirective.resetForm();
    this.initializeFormElements();
  }

  //#endregion

  //#region Clone Data

  rollOverLastQuarterPayroll() {
    this.showLoader = true;
    this.restCallingService.rollOverLastQuarterPayrollV2(this.selectedEmployee['id']).subscribe((newPayRollData) => {
      this.showLoader = false;
      this.currentQuarterData = newPayRollData.json();
        if (!this.currentQuarterData || this.currentQuarterData.length<1) {
          swal('Failure!', 'Please check the data..no records could be rolled over..', 'error');
        } else {
          var rolloverHtmlText = document.createElement("span");
          rolloverHtmlText.innerHTML = 'Payroll data rolled over successfully from the previous quarter!<br /><br /><font color="red">Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.</font>';
          swal({
            icon: 'success',
            title: 'Success!',
            content: rolloverHtmlText,
          }).then(() => {
            this.displaySubmitWarningAlertBox();
          });
        }
    }, err => {
      this.showLoader = false;
      console.log(err.json());
      swal('Failure!', err.json().message,'error');
    });
  }

  clearCurrentQuarterRecords(selectedEmployee: Object) {
    if (!this.currentQuarterData || this.currentQuarterData.length<1) {
      swal('Current Quarter is already clean of all records..');
      return;
    }
    swal({
      title: 'Are you sure?', text: 'Are you sure you want to DELETE ALL RECORDS from current quarter?', icon: 'warning',
      buttons: true
    }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          this.showLoader = true;
          this.restCallingService.clearCurrentQuarterPayrollV2Records(this.selectedEmployee['id']).subscribe((newPayRollData) => {
            this.showLoader = false;
            this.currentQuarterData = newPayRollData.json();
            var clearCurrentQuarterHtmlText = document.createElement("span");
            clearCurrentQuarterHtmlText.innerHTML = 'All Payroll records deleted from current quarter!<br /><br /><font color="red">Please make sure to submit the data for each employee. You must receive a confirmation verifying submission of data.</font>';
            swal({
              icon: 'success',
              title: 'Success!',
              content: clearCurrentQuarterHtmlText,
            })
          }, err => {
            this.showLoader = false;
            console.log(err.json());
            swal('Failure!', err.json().message,'error');
          });
        };
      }
    );
  }

  callSubmitCurrentQuarterService() {
    this.showLoader = true;
    this.restCallingService.submitCurrentQuarter(this.selectedEmployee['id'], this.selectedClient['id']).subscribe(() => {
      this.showLoader = false;
      swal('Success!', 'Current Quarter Submitted for the Employee!', 'success');
    }, err => {
      this.showLoader = false;
      console.log(err.json());
      swal('Failure!', err.json().message,'error');
    });
  }

  submitCurrentQuarter(selectedEmployee: Object) {
    swal({
      title: 'Are you sure?', text: 'Are you sure you want to SUBMIT Current Quarter?', icon: 'warning',
      buttons: true
    }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          if (this.currentQuarterData.length == 0) {
            swal({
              title: 'No Records', text: 'Current Quarter has no payroll records. Are you sure you want to submit?', icon: 'warning',
              buttons: true
            }).then(
              (isConfirmed) => {
                if (isConfirmed) {
                  this.getExceptionsDataForCurrentQuarter(selectedEmployee);
                }
              })
          }
          else {
            this.getExceptionsDataForCurrentQuarter(selectedEmployee);
          }
        }
      });
  }

  getExceptionsDataForCurrentQuarter(selectedEmployee: Object) {
    this.showLoader = true;
    this.restCallingService.getEmployeePayrollV2ExceptionsDataForCurrentQuarter(this.selectedEmployee['id']).subscribe(
      data => {
        this.showLoader = false;
        let exceptionRecords = data.json();
        let invalidRecords: Array<string> = [];
        exceptionRecords.forEach((record) => {
          invalidRecords.push(record['payDate']);
        });
        this.doWarningIfNecessary(invalidRecords);
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, 'error');
      });
  }

  doWarningIfNecessary(invalidRecords: Array<string>) {
    if (invalidRecords.length > 0) {
      var el = document.createElement("p");
      el.innerHTML = 'Total Deductions do not match difference between Gross and Net on the Pay Dates shown below, continue? <br/><br/>';
      for (let date of invalidRecords) {
        el.innerHTML += moment(date).format('MMM DD, YYYY') + '<br/>';
      }
      swal({
        title: 'Are you Sure!', content:el, icon: 'warning', buttons: true
      }).then(
        (isConfirmed) => {
          if (isConfirmed) {
            this.callSubmitCurrentQuarterService();
          }
        })
    }
    else {
      this.callSubmitCurrentQuarterService();
    }
  }

  //#endregion


  //#region UI Methods

  initializeFormElements() {
    // Modifed for V2 Release.
    $('#homeV2').addClass('active');
    $('.two-place-decimal').on('change', (function () {
      $(this).val(parseFloat($(this).val()).toFixed(2).replace('NaN', ''));
    }));
  }

  getQuarterDate(quarterDateYYYYMMDD: string) {
    return moment(quarterDateYYYYMMDD).format('YYYY-MM-DD');
  }

  toggleEmployeeGrid() {
    $('.employee-grid').toggle('slide');
    $('.employee-grid-icon').toggleClass('fa-plus-circle fa-minus-circle');
  }

  toggleLastQuarterGrid() {
    if ($('.last-quarter-icon').hasClass('fa-plus-circle')) { // if the tray is closed, load the data then open it
      if (!this.isLastQuarterDataLoaded) {
        this.loadLastQuarterData();
        this.isLastQuarterDataLoaded = true;
      }
    }
    $('.last-quarter').toggle('slide');
    $('.last-quarter-icon').toggleClass('fa-plus-circle fa-minus-circle');
  }

  toggleCurrentQuarterGrid() {
    if ($('.current-quarter-icon').hasClass('fa-plus-circle')) { // if the tray is closed, load the data then open it
      // this.loadCurrentQuarterData();
    }
    $('.current-quarter').toggle('slide');
    $('.current-quarter-icon').toggleClass('fa-plus-circle fa-minus-circle');
  }

  getMaskedSsn(ssn: string): string {
    try {
      return 'xxx-xx-' + ssn.substr(ssn.length - 4);
    } catch (e) {
      return '';
    }
  }

  filterClientList() {
    if (this.queryClientList !== '' && this.clientList !== undefined) {
      this.filteredClientList = this.clientList.filter(function (el) {
        return (el.name.toLowerCase().indexOf(this.queryClientList.toLowerCase()) >= 0) || (el.payerId.toLowerCase().indexOf(this.queryClientList.toLowerCase()) >= 0);
      }.bind(this));
    } else {
      this.filteredClientList = this.clientList.slice(0, 9);
    }
    this.filteredClientList = this.filteredClientList.slice(0, 9);
  }

  clientFocus() {
    this.filteredClientList = this.clientList.slice(0, 9);
  }

  validateDate(c: FormControl): object {
    /* null means date is okay, otherwise return invalidDate: true */
    if (c.pristine) {
      return null;
    }
    let rawStringValue = '';
    try {
      const formGroup = c.parent.controls;
      const formControlName: string = Object.keys(formGroup).find(name => c === formGroup[name]) || null;
      rawStringValue = $('input[formcontrolname=' + formControlName + ']').val();
    } catch (e) { }
    if (!rawStringValue) {
      rawStringValue = '';
    }
    if (rawStringValue.length < 1) {
      return null;
    }
    let date = moment(rawStringValue, ['MMM DD, YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD', 'MM/DD/YYYY', 'MM-DD-YYYY', 'MMM-DD-YYYY', 'MMM-DD, YYYY']);
    if (date.isValid() && date.isBetween(moment('01/01/1970', 'MM/DD/YYYY'), moment('01/01/9999', 'MM/DD/YYYY'))) {
      return null;
    }
    return { invalidDate: true };
  }

  validateNetPay(c: FormControl): object {
    if (c.pristine || !c.value || c.value === '') {
      return null;
    }
    try {
      const formGroup = c.parent.controls;
      const grossPay: number = formGroup['grossPay'].value;
      const netPay: number = c.value;
      // TODO need to do number conversion
      /*
      if (netPay > grossPay)
        return {invalidNetPay: true };
      */
    } catch (e) { return null; }
    return null;
  }

  validatePayDate(payDate) {
    if (moment(payDate).isBetween(this.currentQuarterStart, this.currentQuarterEnd, null, '[]')) { // [] means inclusive on both date ends
      return true;
    } else {
      return false;
    }
  }

  //#endregion

  //#region General Methods

  //#endregion

  getYtdGrossPay(): number {
    if (this.selectedEmployee) {
      let grossPay: number = this.selectedEmployee['totalGrossPayYtd'];
      /*
      if (this.currentQuarterData) {
        for (let data of this.currentQuarterData) {
          grossPay += data['grossPay'];
        }
      }
      */
      return grossPay;
    }
    else
      return 0;
  }

  totalColumn(columnName: string, data: any) {
    let total: number = 0;
    for (let i = 0; i < data.length; i++) {
      let val = data[i][columnName];
      total += val;
    }
    return total;
  }

  showYtdValues() {
    this.showLoader = true;
    this.restCallingService.getEmployeePayrollV2DataYtdValues(this.selectedEmployee['id']).subscribe((data) => {
      this.showLoader = false;
      let ytdValues:object = data.json();
      var el = document.createElement("p");
      el.innerHTML = "<i>Gross Pay</i>: "+this.decimalPipe.transform(ytdValues['grossPay'], "1.2-2")+
        "<br/><i>Net Pay</i>: "+this.decimalPipe.transform(ytdValues['netPay'], "1.2-2")+
        "<br/><i>Federal Withholding</i>: "+this.decimalPipe.transform(ytdValues['federalWithholding'], "1.2-2")+
        "<br/><i>State Withholding</i>: "+this.decimalPipe.transform(ytdValues['stateWithholding'], "1.2-2")+
        "<br/><i>Medicare Withholding</i>: "+this.decimalPipe.transform(ytdValues['medicareWithholding'], "1.2-2")+
        "<br/><i>Social Security Withholding</i>: "+this.decimalPipe.transform(ytdValues['socialSecurityWithholding'], "1.2-2");
      swal("YTD Values until "+moment(this.currentQuarterStart).subtract(1, "days").format('MMM DD, YYYY')+":", {content: el});
    }, err => {
      this.showLoader = false;
      console.log(err.json());
      swal('Failure!',err.json().message,'error');
    });
  }

  getFilingDueDate():string {
    let s:string = moment(this.currentQuarterEnd).add(1, "months").format('MMM DD, YYYY');
    return s;
  }

  exportQuarter(quarter: string) {
    let tableData: any;
    let fileName: string = "";
    if (quarter == 'current') {
      if (!this.currentQuarterData || this.currentQuarterData.length == 0)
        return;
      else {
        tableData = this.currentQuarterData;
        fileName = 'CURRENT_QUARTER - ' + this.selectedClient['payerId'] + ' - ' + this.selectedEmployee['name'];
      }
    }
    else {
      if (!this.lastQuarterData || this.lastQuarterData.length == 0)
        return;
      else {
        tableData = this.lastQuarterData;
        fileName = 'LAST_QUARTER - ' + this.selectedClient['payerId'] + ' - ' + this.selectedEmployee['name'];
      }
    }
    let data: any = [];
    let columns: any = [];
    let columnMap : Map<string,string> = new Map<string, string>();
    columnMap.set('payDate', 'Pay Date');
    columnMap.set('startDate', 'Start Date');
    columnMap.set('endDate', 'End Date');
    columnMap.set('allowanceType', 'Allowance Type') ;
    columnMap.set('grossPay', 'Gross Pay');
    columnMap.set('medicareWithholding', 'Medicare');
    columnMap.set('socialSecurityWithholding', 'Social Security');
    columnMap.set('federalWithholding', 'Federal');
    columnMap.set('stateWithholding', 'State');
    columnMap.set('netPay', 'Net Pay');
    columnMap.set('payFrequencyType', 'Pay Frequency Type');
    for (let colName in tableData[0]) {
      if (colName.includes('udf')) {
        let udfObj: any = this.udfData.find(x => x.key == colName);
        if (udfObj) {
          columnMap.set(udfObj.key, udfObj.value);
        }
      }
      else if (colName.includes('localWithholding')) {
        let localObj: any = this.localWithholding.find(x => x.newKey == colName);
        if (localObj) {
          columnMap.set(localObj.newKey, localObj.value);
        }
      }
    }
    for (let colName of Array.from(columnMap.values())) {
      columns.push(colName);
    }
    data.push(columns);
    for(let row of tableData) {
      let record: any = [];
      for (let col of Array.from(columnMap.keys())) {
        if (col.includes('Type') || col.includes('Date'))
          record.push(row[col] || ''); // format nulls for dates/enums as empty string
        else
          record.push(row[col] || 0.00) // format nulls for money as 0.00
      }
      data.push(record);
    }
    alasql.promise('SELECT * INTO CSV(\"'+fileName+'.CSV\", {headers:false, separator:","\}) FROM ?', [data])
      .then(function () {
        console.log('Data saved');
      }).catch(function (err) {
        console.log('Error:', err);
      });
  }

/*launchClientPortal() {
    this.showLoader = true;
    let obj = { };
    let ary = [ ];
    ary.push(this.selectedClient['id']);
    obj["clientIdList"] = ary;
    this.restCallingService.getClientPortalSsoLoginUrl(obj).subscribe((responseData) => {
      this.showLoader = false;
      let returnObject = responseData.json();
      console.log(returnObject["clientPortalSsoLoginUrl"]);
      let url = returnObject["clientPortalSsoLoginUrl"];
      // let url = 'https://clientportal-uat.eisneramper.com/clientportalinternal/ILogin.aspx?rst=true'; //for testing
      $('#clientPortalIFrame').attr('src', url);
    }, err => {
      this.showLoader = false;
      console.log(err.json());
      swal('Failure!', err.json().message,'error');
    });
  }*/

  launchClientPortalTab() {
    this.showLoader = true;
    let obj = { };
    let ary = [ ];
    ary.push(this.selectedClient['id']);
    obj["clientIdList"] = ary;
    this.restCallingService.getClientPortalSsoLoginUrl(obj).subscribe((responseData) => {
      this.showLoader = false;
      let returnObject = responseData.json();
      console.log(returnObject["clientPortalSsoLoginUrl"]);
      let url = returnObject["clientPortalSsoLoginUrl"];
      // let url = 'https://clientportal-uat.eisneramper.com/clientportalinternal/ILogin.aspx?rst=true'; //for testing
      // window.open(returnObject["clientPortalSsoLoginUrl"],'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,fullscreen=yes');
      // window.open(url, '_blank');
      let w = window.open(url, 'NannyTaxClientPortalIntegrationWindow');
      if(!w || w.closed || typeof w.closed=='undefined')
        swal('Popup Blocked?', 'Please make sure that you have popup blocker turned off for NannyTax because when you click the “Launch Document Portal” button it will open the portal in new tab.', 'info');
    }, err => {
      this.showLoader = false;
      console.log(err.json());
      swal('Failure!', err.json().message,'error');
    });
  }

  isShowLaunchControlWorksheet() {
    if (!this.selectedClient)
      return false;
    if (this.isExternalClient)
      return false;
    /*try {
      let ua: any = window.navigator.userAgent;
      let trident: any = ua.indexOf('Trident/');
      if (trident <= 0)
        return false;
    } catch (e) {
      return false;
    }*/
    return true;
  }

  launchControlWorksheet() {
    let that = this;
    let el = document.createElement("select");
    this.fillControlWorksheetStateOptions(el);
    el.value = this.selectedClient['state'];
    swal({
      title: 'Select State',
      content: el,
      buttons: {
        cancel: true,
        confirm: true
      }
    }).then(function (result) {
      el.parentNode.removeChild(el);
      if (result)
        that.launchControlWorksheetWithState(el.value);
    });
  }

  launchControlWorksheetWithState(state: string) {
    this.showLoader = true;
    /*this.restCallingService.getClientControlWorkbookInfo(this.selectedClient['id'], state).subscribe(
      data => {
        this.showLoader = false;
        this.launchControlWorksheetWithData(data.json(), state);
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal('Failure!', err.json().message,'error');
      }
    );*/
    this.restCallingService.getClientControlWorkbookInfoV2(this.selectedClient['id'], state).subscribe(
      data => {
        this.showLoader = false;
        const blob = this.restCallingService.b64toBlob(data.text(), 'application/vnd.ms-excel', 512);  
        this.restCallingService.downloadBlob(blob,"ControlWorksheet"+state+".xlsx");
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal('Failure!', err.json().message,'error');
      }
    );
  }

  /*launchControlWorksheetWithData(data: object, state: string) {
    var w = new ActiveXObject("Excel.Application");
    w.Visible = true;
    w.Workbooks.Open(environment.serverPrefix + "/assets/docs/control-worksheets/ControlWorksheet"+state+".xlsx");
    w.Application.Sheets("Q1").Activate;
    w.ActiveSheet.Cells(1, 1).Value = data['payerInfo'];
    w.ActiveSheet.Cells(1, 9).Value = data['sutaRate1'];
    w.Application.Sheets("Q2").Activate;
    w.ActiveSheet.Cells(1, 9).Value = data['sutaRate2'];
    w.Application.Sheets("Q3").Activate;
    w.ActiveSheet.Cells(1, 9).Value = data['sutaRate3'];
    w.Application.Sheets("Q4").Activate;
    w.ActiveSheet.Cells(1, 9).Value = data['sutaRate4'];
    w.Application.Sheets("Q1").Activate;
    let employeeInfoList: Array<object> = data['employeeInfoList'];
    let employeeCounter: number = 0;
    employeeInfoList.forEach((employeeInfo) => {
      w.ActiveSheet.Cells(8+employeeCounter, 1).Value = employeeInfo['name'];
      employeeCounter++;
    });
    employeeInfoList = data['employeeInfoList'];
    employeeCounter = 0;
    employeeInfoList.forEach((employeeInfo) => {
      let quarterInfoList: Array<object> = employeeInfo['quarterInfoList'];
      let quarterCounter: number = 1;
      if (quarterInfoList) {
        quarterInfoList.forEach((quarterInfo) => {
          w.Application.Sheets("Q"+quarterCounter).Activate;
          w.ActiveSheet.Cells(8+employeeCounter, 4).Value = quarterInfo['gross'];
          w.ActiveSheet.Cells(8+employeeCounter, 5).Value = quarterInfo['xfica'];
          w.ActiveSheet.Cells(8+employeeCounter, 10).Value = quarterInfo['federalWithholding'];
          w.ActiveSheet.Cells(8+employeeCounter, 11).Value = quarterInfo['stateWithholding'];
          w.ActiveSheet.Cells(8+employeeCounter, 12).Value = quarterInfo['cityWithholding'];
          quarterCounter++;
        });
      }
      employeeCounter++;
    });
    w.Application.Sheets("Q1").Activate;
  }*/

  fillControlWorksheetStateOptions(el) {
    this.fillControlWorksheetStateOptionsCreateOption("CA: California", "CA", el);
    this.fillControlWorksheetStateOptionsCreateOption("CT: Connecticut", "CT", el);
    this.fillControlWorksheetStateOptionsCreateOption("DC: District of Columbia", "DC", el);
    this.fillControlWorksheetStateOptionsCreateOption("FL: Florida", "FL", el);
    this.fillControlWorksheetStateOptionsCreateOption("GA: Georgia", "GA", el);
    this.fillControlWorksheetStateOptionsCreateOption("IL: Illinois", "IL", el);
    this.fillControlWorksheetStateOptionsCreateOption("MA: Massachusetts", "MA", el);
    this.fillControlWorksheetStateOptionsCreateOption("MD: Maryland", "MD", el);
    this.fillControlWorksheetStateOptionsCreateOption("NC: North Carolina", "NC", el);
    this.fillControlWorksheetStateOptionsCreateOption("NJ: New Jersey", "NJ", el);
    this.fillControlWorksheetStateOptionsCreateOption("NY: New York", "NY", el);
    this.fillControlWorksheetStateOptionsCreateOption("PA: Pennsylvania", "PA", el);
    this.fillControlWorksheetStateOptionsCreateOption("TX: Texas", "TX", el);
    this.fillControlWorksheetStateOptionsCreateOption("UT: Utah", "UT", el);
    this.fillControlWorksheetStateOptionsCreateOption("VA: Virginia", "VA", el);
  }

  fillControlWorksheetStateOptionsCreateOption(textString: string, valueString: string, el: any) {
    let option;
    option = document.createElement("option");
    option.text = textString;
    option.value = valueString;
    el.appendChild(option);
  }

  populateWithholdingsBasedOnGrossPay() {
    /*Medicare Withholding: Gross Pay * MCWH
      Social Security Withholding: Gross Pay * SSWH
      Net: Gross Pay * (100% - MCWH- SSWH) */

    /* XFICA = Gross Pay * (MCWH + SSWH) / (1 + MCWH + SSWH)
       So, XFICA = Gross Pay * (0.0765) / (1.0765)
       Medicare Withholding: (Gross Pay – XFICA) * MCWH
       Social Security Withholding: (Gross Pay – XFICA) * SSWH
       Net: Gross Pay – Medicare Withholding Amount - Social Security Withholding Amount
  */
    let XFICA = this.quarterForm.controls['XFICA'].value;
    let grossPay = this.quarterForm.controls['grossPay'].value;
    let netPay = this.quarterForm.controls['netPay'].value;

    if (grossPay === null) {
      return;
    }
    let isPayFieldNull = this.nullCheckForOtherPayFields(netPay);

    if (XFICA) {
      if (isPayFieldNull) {
        let xfica = grossPay * (this.MCWHNumber + this.SSWHNumber) / (1 + this.MCWHNumber + this.SSWHNumber);
        let medicareWithholding = (grossPay - xfica) * this.MCWHNumber;
        this.quarterForm.controls['medicareWithholding'].setValue(medicareWithholding.toFixed(2));

        let ssnWithholding = (grossPay - xfica) * this.SSWHNumber;
        this.quarterForm.controls['socialSecurityWithholding'].setValue(ssnWithholding.toFixed(2));

        let netPay = grossPay - medicareWithholding - ssnWithholding;
        this.quarterForm.controls['netPay'].setValue(netPay.toFixed(2));
      }
    } else {
      if (isPayFieldNull) {
        let medicareWithholding = grossPay * this.MCWHNumber;
        this.quarterForm.controls['medicareWithholding'].setValue(medicareWithholding.toFixed(2));

        let ssnWithholding = grossPay * this.SSWHNumber;
        this.quarterForm.controls['socialSecurityWithholding'].setValue(ssnWithholding.toFixed(2));

        let netPay = grossPay * (1 - this.MCWHNumber - this.SSWHNumber);
        this.quarterForm.controls['netPay'].setValue(netPay.toFixed(2));
      }
    }
  }

  populateWithholdingsBasedOnNetPay() {
    /* Gross: Net Pay / (100% - MCWH – SSWH)
       Medicare Withholding: (Net Pay/ (100% - MCWH - SSWH)) * MCWH
       Social Security Withholding: (Net Pay/ (100% - MCWH - SSWH)) * SSWH
    */
    let netPay = this.quarterForm.controls['netPay'].value;
    let grossPay = this.quarterForm.controls['grossPay'].value;

    if (netPay === null) {
      return;
    }

    let isPayFieldNull = this.nullCheckForOtherPayFields(grossPay);
    if (isPayFieldNull) {
      let grossPay = netPay / (1 - this.MCWHNumber - this.SSWHNumber);
      this.quarterForm.controls['grossPay'].setValue(grossPay.toFixed(2));

      let medicareWithholding = (netPay / (1 - this.MCWHNumber - this.SSWHNumber)) * this.MCWHNumber;
      this.quarterForm.controls['medicareWithholding'].setValue(medicareWithholding.toFixed(2));

      let ssnWithholding = (netPay / (1 - this.MCWHNumber - this.SSWHNumber)) * this.SSWHNumber;
      this.quarterForm.controls['socialSecurityWithholding'].setValue(ssnWithholding.toFixed(2));
    }
  }

  nullCheckForOtherPayFields(payField) {
    let isPayFieldNull: boolean;
    let federalWH = this.quarterForm.controls['federalWithholding'].value;
    let stateWH = this.quarterForm.controls['stateWithholding'].value;
    let medicareWH = this.quarterForm.controls['medicareWithholding'].value;
    let socialSecurityWH = this.quarterForm.controls['socialSecurityWithholding'].value;
    let udfFiledsNullCheck = true;
    let localFiledsNullCheck = true;

    for (var i = 0; i < this.udfData.length; i++) {
      if (this.quarterForm.controls[this.udfData[i].key].value !== null) {
        udfFiledsNullCheck = false;
        break;
      }
    }

    for (var i = 0; i < this.localWithholding.length; i++) {
      if (this.quarterForm.controls[this.localWithholding[i].newKey].value !== null) {
        localFiledsNullCheck = false;
        break;
      }
    }

    if (payField === null && medicareWH === null && socialSecurityWH === null && federalWH === null && stateWH === null && udfFiledsNullCheck && localFiledsNullCheck) {
      isPayFieldNull = true;
    } else {
      isPayFieldNull = false;
    }

    return isPayFieldNull;
  }

  onXFICAChange() {
    this.quarterForm.controls['grossPay'].setValue(null);
    this.quarterForm.controls['netPay'].setValue(null);
    this.quarterForm.controls['medicareWithholding'].setValue(null);
    this.quarterForm.controls['socialSecurityWithholding'].setValue(null);
    this.quarterForm.controls['federalWithholding'].setValue(null);
    for (var i = 0; i < this.udfData.length; i++) {
      if (this.quarterForm.controls[this.udfData[i].key].value !== null) {
        this.quarterForm.controls[this.udfData[i].key].setValue(null);
      }
    }

    for (var i = 0; i < this.localWithholding.length; i++) {
      if (this.quarterForm.controls[this.localWithholding[i].newKey].value !== null) {
        this.quarterForm.controls[this.localWithholding[i].newKey].setValue(null);
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/client-payroll-management/client-payroll-management.component.ts